









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Checkout extends Vue {
  @Prop() private header!: string;
}
